import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class LicitacionService {
	constructor(private http: HttpClient) {}

	UploadImage(file: File) {
		var formData = new FormData();
		formData.append('file', file);
		return this.http.post(`https://fundacionbest.org.mx/Webapi/best/api/Licitaciones/UploadFile`, formData, {
			headers: {
				'Accept': 'application/json'
			}
		})
	}
	
	getFamiliaIntere() {
		return this.http.get(`https://fundacionbest.org.mx/Webapi/best/api/Licitaciones/familias`);
	}

	familiasAdmini() {
		return this.http.get(`https://fundacionbest.org.mx/Webapi/best/api/Licitaciones/familiasAdmini`);
	}


	getcalificaciones() {
		return this.http.get(`https://fundacionbest.org.mx/Webapi/best/api/Licitaciones/calificaciones`);
	}

	
	calificacionesadmin() {
		return this.http.get(`https://fundacionbest.org.mx/Webapi/best/api/Licitaciones/Getcalificacionesadmin`);
	}
	
	
	getOfertas(token: any) {
		return this.http.get(`https://fundacionbest.org.mx/Webapi/best/api/Licitaciones/Productos`, {
			headers: {
			  'Content-Type': 'application/json',
			  Authorization: `Bearer ${token}`
			}
		  });
	}

	productosShare(text : any, token: any) {
		let params = new HttpParams().set('text', text);
		return this.http.get(`https://fundacionbest.org.mx/Webapi/best/api/Licitaciones/productosShare`, {
			params: params,
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`
			  }
			});
	  }

	  productosFamilyShare(text : any, token: any) {
		let params = new HttpParams().set('Idfamilia', text);
		return this.http.get(`https://fundacionbest.org.mx/Webapi/best/api/Licitaciones/productosFamilyShare`, {
			params: params,
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`
				}
		});
	}

	getproductosAdmin(token: any) {
		return this.http.get(`https://fundacionbest.org.mx/Webapi/best/api/Licitaciones/productosAdmin`, {
			headers: {
			  'Content-Type': 'application/json',
			  Authorization: `Bearer ${token}`
			}
		  });
	}
	
	getPostulacionbyid(rfc: any, token: any) {
		let params = new HttpParams().set('rfc', rfc);
		return this.http.get(`https://fundacionbest.org.mx/Webapi/best/api/Licitaciones/postulacionbyid`,  {
			params: params,
			headers: {
			  'Content-Type': 'application/json',
			  Authorization: `Bearer ${token}`
			}
		  });
	}

	PostDelpostulacionbyid(id: any, token: any) {
		let params = new HttpParams().set('id', id);
		return this.http.get(`https://fundacionbest.org.mx/Webapi/best/api/licitaciones/DeletePostulacion`, {
			params: params,
			headers: {
			  'Content-Type': 'application/json',
			  Authorization: `Bearer ${token}`
			}
		  });
	}

	GetProvedoresbyId(id: any, token: any) {
		let params = new HttpParams().set('id', id);
		return this.http.get(`https://fundacionbest.org.mx/Webapi/best/api/licitaciones/GetProvedoresbyId`, {
			params: params,
			headers: {
			  'Content-Type': 'application/json',
			  Authorization: `Bearer ${token}`
			}
		  });
	}

	GetProveedor(rfc: any, token: any) {
		let params = new HttpParams().set('rfc', rfc);
		return this.http.get(`https://fundacionbest.org.mx/Webapi/best/api/licitaciones/DetalleProvedoor`, {
			params: params,
			headers: {
			  'Content-Type': 'application/json',
			  Authorization: `Bearer ${token}`
			}
		  });
	}

	postLoginProvedor(Proveedor: any) {
		return this.http.post(`https://fundacionbest.org.mx/Webapi/best/api/Login/logginproveedor`, Proveedor, {
			headers: {
				'Accept': 'application/json'
			}
		})
	}
	
	postOfertas(formulario: any, token: any) {
		return this.http.post(`https://fundacionbest.org.mx/Webapi/best/api/licitaciones/Postulacion`, formulario, {
			headers: {
			  'Content-Type': 'application/json',
			  Authorization: `Bearer ${token}`
			}
		  });
	}

	postRecoverypass(correo: any) {
		return this.http.post(`https://fundacionbest.org.mx/Webapi/best/api/Licitaciones/RecoveryPassword`, correo, {
			headers: {
				'Accept': 'application/json'
			}
		})
	}

	postResetPass(correo: any) {
		return this.http.post(`https://fundacionbest.org.mx/Webapi/best/api/Licitaciones/ResetPass`, correo, {
			headers: {
				'Accept': 'application/json'
			}
		})
	}
	
	postNewProveedor(postulante: any) {
		return this.http.post(`https://fundacionbest.org.mx/Webapi/best/api/Licitaciones/`, postulante, {
			headers: {
				'Accept': 'application/json'
			}
		})
	}

	postForgotPass(Proveedor: any) {
		return this.http.post(`https://fundacionbest.org.mx/Webapi/best/api/Licitaciones/RecoveryPassword`, Proveedor, {
			headers: {
				'Accept': 'application/json'
			}
		})
	}


	postUpdateProve(postulante: any, token : any) {
		return this.http.post(`https://fundacionbest.org.mx/Webapi/best/api/Licitaciones/UpdateProve`, postulante,{
			headers: {
			  'Content-Type': 'application/json',
			  Authorization: `Bearer ${token}`
			}
		  });
	}

	postLoginLicAdm(Proveedor: any) {
		return this.http.post(`https://fundacionbest.org.mx/Webapi/best/api/Login/logginliciadmin`, Proveedor, {
			headers: {
				'Accept': 'application/json'
			}
		})
	}
  
	postInsertFamilia(familia: any, token : any) {
		return this.http.post(`https://fundacionbest.org.mx/Webapi/best/api/Licitaciones/InsertFamilia`, familia,{
			headers: {
			  'Content-Type': 'application/json',
			  Authorization: `Bearer ${token}`
			}
		  });
	}

	postUpdateFamilia(familia: any, token : any) {
		return this.http.post(`https://fundacionbest.org.mx/Webapi/best/api/Licitaciones/UpdateFamilia`, familia,{
			headers: {
			  'Content-Type': 'application/json',
			  Authorization: `Bearer ${token}`
			}
		  });
	}
	postInsertCalificacion(calificacion: any, token : any) {
		return this.http.post(`https://fundacionbest.org.mx/Webapi/best/api/Licitaciones/InsertCalificacion`, calificacion,{
			headers: {
			  'Content-Type': 'application/json',
			  Authorization: `Bearer ${token}`
			}
		  });
	}

	postUpdateCalificacion(calificacion: any, token : any) {
		return this.http.post(`https://fundacionbest.org.mx/Webapi/best/api/Licitaciones/UpdateCalificacion`, calificacion,{
			headers: {
			  'Content-Type': 'application/json',
			  Authorization: `Bearer ${token}`
			}
		  });
	}
	postInsertProducto(calificacion: any, token : any) {
		return this.http.post(`https://fundacionbest.org.mx/Webapi/best/api/Licitaciones/InsertOferta`, calificacion,{
			headers: {
			  'Content-Type': 'application/json',
			  Authorization: `Bearer ${token}`
			}
		  });
	}

	postUpdateProducto(calificacion: any, token : any) {
		return this.http.post(`https://fundacionbest.org.mx/Webapi/best/api/Licitaciones/UpdateOferta`, calificacion,{
			headers: {
			  'Content-Type': 'application/json',
			  Authorization: `Bearer ${token}`
			}
		  });
	}

	postUpdateprogreso(calificacion: any, token : any) {
		return this.http.post(`https://fundacionbest.org.mx/Webapi/best/api/Licitaciones/Updateprogreso`, calificacion,{
			headers: {
			  'Content-Type': 'application/json',
			  Authorization: `Bearer ${token}`
			}
		  });
	}
}